export enum routes {
  root = '/',
  welcome = '/welcome',
  login = '/login',
  downloadReport = '/downloadReport',
  classificationQueue = '/classification-queue',
  classificationDetailStep1 = '/classification-detail-step-one',
  componentSplitter = '/component-spliter',
  componentCoding = '/component-coding',
  componentEntriesReview = '/component-entries-review',
  classificationDetailStep2 = '/classification-detail-step-two',
  classificationAttribute = '/classification-attribute',
  attributes = '/attributes',
  componentEntries = '/component-entries',
  componentCostAllocation = '/component-cost-allocation',
  dashboard = '/dashboard',
  dashboardReport = '/user-reports',
  indexingQueue = '/indexing-queue',
  indexingDetailStepOne = '/indexing-detail-step-one',
  clientReference = '/clientreference',
  componentQueue = '/component-queue',
  product = '/product',
  subCategory = '/sub-category',
  category = '/category',
  advertiser = '/advertiser',
  industry = '/industry',
  roles = '/roles',
  users = '/users',
  auditQueueSetup = '/audit-queue-setup',
  gridColumnCustomization = '/grid-column-customization',
  universalSearchSetup = '/universal-search-setup',
  componentAttribute = '/component-attribute',
  mediaGroup = '/media-group',
  languageGroup = '/language-group',
  media = '/media',
  componentProgramTemplate = '/component-program-template',
  indexingTemplate = '/indexing-template',
  language = '/language',
  profiles = '/profiles',
  presaleAd = '/presale-ad',
  divi = '/divi',
  project = '/project',
  about = '/about',
  audit = '/audit',
  auditQueue = '/audit-queue',
  universalSearch = '/universal-search',
  indexingAttribute = '/indexing-attribute',
  queryQueue = '/query-queue',
  pageNotFound = '*',
  tvprogram = '/tv-program',
  tvprogrammap = '/tv-program-map',
  tvprogramsource = '/source',
  playMedia = '/play-media',
  celebrity = '/celebrity',
  market = '/market',
  tagline = '/tagline',
  bulkEditFields = '/bulk-edit-fields',
  bulkEditConfirmation = '/bulk-edit-confirmation',
  collection = '/collection',
  customFlagAttribute = '/customflag-attribute'
}
